module.exports = __webpack_public_path__ + "static/media/p6_bkg.87de5e27.png";